// 声明全局变量，防止 HMR 时重复添加监听器
declare global {
  var __nuxt_error_handler_initialized: boolean
  var __nuxt_client_error_initialized: boolean
  var __nuxt_reloading: boolean
}

export default defineNuxtPlugin((nuxtApp) => {
  // ==================== 服务端错误处理 ====================
  if (import.meta.server) {
    if (!globalThis.__nuxt_error_handler_initialized) {
      const handleUnhandledRejection = (error: any) => {
        if (error?.code === 'ECONNRESET' || error?.code === 'ETIMEDOUT') {
          console.log('Caught unhandled rejection (connection reset):', error.message)
          return
        }
        console.error('Unhandled rejection:', error)
      }

      process.on('unhandledRejection', handleUnhandledRejection)
      globalThis.__nuxt_error_handler_initialized = true
      // 注意：Nuxt 服务端没有 'close' 钩子，无需手动移除
      // process 级别的监听器在进程退出时自动清理
    }
  }

  // ==================== 客户端错误处理 ====================
  if (import.meta.client && !globalThis.__nuxt_client_error_initialized) {
    const handleClientRejection = (event: PromiseRejectionEvent) => {
      const reasonMsg = String(event.reason?.message ?? event.reason)

      // 模块加载失败：委托给 module-error-handler 插件
      if (reasonMsg.includes('Failed to fetch dynamically imported module') ||
          reasonMsg.includes('Failed to load module script') ||
          reasonMsg.includes('H3Error: Failed to fetch')) {
        console.log('Module loading error detected, delegating to module-error-handler')
        return
      }

      console.error('Unhandled promise rejection:', event.reason)
      event.preventDefault()
    }

    window.addEventListener('unhandledrejection', handleClientRejection)
    globalThis.__nuxt_client_error_initialized = true
  }

  // ==================== Nuxt 应用级错误 ====================
  nuxtApp.hook('app:error', (error) => {
    const errorString = String(error?.toString?.() ?? error)
    if (errorString.includes('Failed to fetch dynamically imported module') ||
        errorString.includes('Failed to load module script') ||
        errorString.includes('H3Error: Failed to fetch')) {
      console.warn('🔄 Module load error in app:error — reloading to recover')
      if (import.meta.client && !globalThis.__nuxt_reloading) {
        globalThis.__nuxt_reloading = true
        setTimeout(() => window.location.reload(), 100)
      }
      return
    }
    console.error('App error:', error)
  })

  // ==================== Vue 组件级错误 ====================
  nuxtApp.vueApp.config.errorHandler = (error: unknown, _instance, info) => {
    const errorString = String(error?.toString?.() ?? error)

    if (errorString.includes('Failed to fetch dynamically imported module')) {
      console.warn('Module loading error caught in Vue error handler')
      return
    }

    console.error('Vue error:', error, info)
  }
})


